import { useCallback } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { notify } from '../notify/notify'
import './blob.css'
interface BlobModalComponentProperties {
  modalVisible: boolean
  closeModal: any
  blobName: string
  blobData: any
  raw?: string
}

const BlobModalComponent = (props: BlobModalComponentProperties) => {
  const handleCopyClicked = useCallback((e) => {
    const copy = async function(){
      if (!props.raw) return

      await navigator.clipboard.writeText(props.raw)
      notify('success', 'Copied content to clipboard!')
    }
    copy()
  }, [props.raw])

  return (
    <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
      <Modal.Header 
        closeButton
        style={{ 
          position: 'sticky', 
          top: -1, 
          zIndex: 1050, 
          backgroundColor: 'white', 
          borderBottom: '1px solid #ddd'
        }}
      >
        <Modal.Title>
          {props.blobName}
          {props.raw && 
            <>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className='button-like' style={{float: 'right', cursor: 'pointer'}} title='Copy content to clipboard' onClick={handleCopyClicked}>
                <svg
                  height='16'
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-6 h-6"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
              </span>
            </>
          }
        </Modal.Title>
      </Modal.Header>
        
      <Modal.Body>
        {props.blobData}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' onClick={props.closeModal}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BlobModalComponent
